/**
 * Environment configuration for Vite
 * This file uses import.meta.env directly and is compiled by Vite
 */

// Direct access to Vite environment variables
// These will be replaced at build time by Vite
const VAPID_KEY = import.meta.env.VITE_APP_VAPID_KEY as string;
const FIREBASE_API_KEY = import.meta.env.VITE_APP_FIREBASE_API_KEY as string;
const FIREBASE_PROJECT_ID = import.meta.env.VITE_APP_FIREBASE_PROJECT_ID as string;
const LOGO_DEV_TOKEN = (import.meta.env.VITE_APP_LOGO_DEV_TOKEN as string) || 'pk_MslynujWS9CB7Wu8dYFt-g';
const APPSFLYER_DEV_KEY = import.meta.env.VITE_APPSFLYER_DEV_KEY as string;
const APPSFLYER_APP_ID = import.meta.env.VITE_APPSFLYER_APP_ID as string;

// Debug logging (development only)
if (import.meta.env.DEV) {
  console.log('[ENV-DEBUG] Environment variables loaded:', {
    VAPID_KEY: VAPID_KEY ? `${VAPID_KEY.substring(0, 10)}...` : 'EMPTY',
    FIREBASE_API_KEY: FIREBASE_API_KEY ? `${FIREBASE_API_KEY.substring(0, 10)}...` : 'EMPTY',
    FIREBASE_PROJECT_ID: FIREBASE_PROJECT_ID || 'EMPTY',
    LOGO_DEV_TOKEN: LOGO_DEV_TOKEN ? `${LOGO_DEV_TOKEN.substring(0, 10)}...` : 'EMPTY',
    APPSFLYER_DEV_KEY: APPSFLYER_DEV_KEY ? `${APPSFLYER_DEV_KEY.substring(0, 10)}...` : 'EMPTY',
    APPSFLYER_APP_ID: APPSFLYER_APP_ID || 'EMPTY',
  });
}

// Export constants
export const VITE_APP_VAPID_KEY = VAPID_KEY || '';
export const VITE_APP_FIREBASE_API_KEY = FIREBASE_API_KEY || '';
export const VITE_APP_FIREBASE_PROJECT_ID = FIREBASE_PROJECT_ID || '';
export const VITE_APP_LOGO_DEV_TOKEN = LOGO_DEV_TOKEN;
export const VITE_APPSFLYER_DEV_KEY = APPSFLYER_DEV_KEY || '';
export const VITE_APPSFLYER_APP_ID = APPSFLYER_APP_ID || '';

// Helper functions
export const getVapidKey = (): string => VITE_APP_VAPID_KEY;
export const getFirebaseApiKey = (): string => VITE_APP_FIREBASE_API_KEY;
export const getFirebaseProjectId = (): string => VITE_APP_FIREBASE_PROJECT_ID;
export const getLogoDevToken = (): string => VITE_APP_LOGO_DEV_TOKEN;
export const getAppsFlyerDevKey = (): string => VITE_APPSFLYER_DEV_KEY;
export const getAppsFlyerAppId = (): string => VITE_APPSFLYER_APP_ID;

// Validation helpers
export const isVapidKeyConfigured = (): boolean => !!VITE_APP_VAPID_KEY;
export const isFirebaseConfigured = (): boolean => !!VITE_APP_FIREBASE_API_KEY && !!VITE_APP_FIREBASE_PROJECT_ID;
export const isLogoDevConfigured = (): boolean => !!VITE_APP_LOGO_DEV_TOKEN;
export const isAppsFlyerConfigured = (): boolean => !!VITE_APPSFLYER_DEV_KEY && !!VITE_APPSFLYER_APP_ID;

// Environment mode helpers
export const isProduction = (): boolean => import.meta.env.MODE === 'production';
export const isDevelopment = (): boolean => import.meta.env.MODE === 'development';
